import { AxiosResponse } from 'axios';
import { useMutation } from '@tanstack/react-query';
import { NotificationMessage } from '../../../../../../components';
import * as service from '../services';
import { CreateCustomSegmentDTO } from '../types';
import { useSetupISACustomSegmentsStore } from '../SetupISACustomSegments.store';
import { useGetCustomSegmentTableList } from './useGetCustomSegmentTableList';
import { hasNameInString } from '../utils';

export const useSaveCustomSegment = (setValue: (key: string, value: any) => void, setError: (key: string, value: any) => void) => {
  const { setCreateEditSegmentCloseModal } = useSetupISACustomSegmentsStore();
  const { handleChangeCustomSegmentPage } = useGetCustomSegmentTableList();

  const successAction = (data: AxiosResponse) => {
    const rawMessage = data.data[0]?.mensagem ?? '';
    const errorMessage = rawMessage.replace('IllegalArgumentException: ', '');
    const successMessage = 'Segmentos foram salvos com sucesso';

    if (data.status !== 200) {
      const isNameError = hasNameInString(rawMessage);
      if (isNameError) {
        setError('segment_name', { message: errorMessage });
      } else {
        NotificationMessage('error', 5000, errorMessage);
      }
      return;
    }

    setCreateEditSegmentCloseModal();
    handleChangeCustomSegmentPage(1);
    setValue('segment_name', '');
    setValue('items', []);
    NotificationMessage('success', 5000, successMessage);
  };

  const errorAction = () => {
    setCreateEditSegmentCloseModal();
    NotificationMessage('error', 5000, 'Erro ao salvar segmentos');
  };

  const saveSegmentMutation = useMutation({
    mutationFn: (payload: CreateCustomSegmentDTO) => service.saveCustomSegment(payload),
    onSuccess: successAction,
    onError: errorAction,
  });

  return {
    isSaveLoading: saveSegmentMutation.isPending,
    handleSaveSegmentMutation: saveSegmentMutation.mutate,
  };
};
